module.exports = __webpack_public_path__ + "static/media/vaht.01f831c8.jpg";